import { strings } from '../../localization';
import errorReporting from 'APP_ROOT/services/errorReporting';
import events from 'APP_ROOT/data/events';

//create a custom event
(function () {
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

Math.radians = function (degrees) {
    return degrees * Math.PI / 180;
};

var toTitleCase = function (string) {
    return string.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

var allowedEvents = [
    "EVENT_AIR_PRESSURE_CHANGE",
    "EVENT_SOUND_IMPULSE",
    "EVENT_GPS_MOVEMENT",
    "EVENT_ACCIDENT",
    "EVENT_RAVEN_UNPLUGGED",
    "EVENT_CAR_BATTERY_LOW",
    "EVENT_AGGRESSIVE_ACCELERATION",
    "EVENT_HARD_BRAKING",
    "EVENT_HARD_CORNERING",
    "EVENT_OBD_DTC_ALERT",
    "EVENT_OBD_DTC_CLEARED",
    "EVENT_ENGINE_ON",
    "EVENT_ENGINE_OFF",
    "EVENT_RAVEN_PLUGGED_IN", // Raven powered up.  level of 12 is 12V (in car), 5 is USB power
    "EVENT_RAVEN_SHUTDOWN", // Raven is shutting down

    "EVENT_RAVEN_BT_BUTTON_SHORT_PRESS",
    // "EVENT_RAVEN_BT_BUTTON_LONG_PRESS",
    "EVENT_REMOTE_REQUEST",

    "EVENT_ENGINE_UNKNOWN",

    "EVENT_RAVEN_USER_SHUTDOWN", // Raven is shutting down by user action

    "EVENT_CAR_BUMPED",
    "EVENT_SPEEDING_STARTED",
    "EVENT_SPEEDING_STOPPED",
    "EVENT_SPEEDING_MERGED", // runtime event, created by webapp for merged single speeding event (ie. no teardrop-shaped icon, no started/stopped language, etc)

    "EVENT_KLOUD_GEOFENCE_ENTER", // These probably can be removed
    "EVENT_KLOUD_GEOFENCE_EXIT", // These probably can be removed

    "EVENT_RAVEN_GEOFENCE_ENTER",
    "EVENT_RAVEN_GEOFENCE_EXIT",

    "EVENT_KLOUD_DRIVER_DETECTED",
    "EVENT_KLOUD_PASSENGER_DETECTED",

    "EVENT_IDLING_STARTED",
    "EVENT_IDLING_STOPPED",
    "EVENT_IDLING_MERGED", // runtime event, created by webapp for merged single idling event (ie. no teardrop-shaped icon, no started/stopped language, etc)

    "EVENT_RAVEN_DEBUG_EVENT",
    "EVENT_KLOUD_DEBUG_EVENT",

    "EVENT_KLOUD_LIVE_STREAMING",
    "EVENT_KLOUD_HISTORICAL_STREAMING",

    // TEMPORARY SHOWCASE EVENTS FOR CES 2020
    "EVENT_DEMO_MAPBOX_TAILGATING",
    "EVENT_DEMO_MAPBOX_ROLLING_STOP",
    "EVENT_DEMO_MAPBOX_SAFETY_WARNING", // Pedestrian or Cyclist
    "EVENT_DEMO_DS4_ALARM_ON",
    "EVENT_DEMO_DS4_ALARM_OFF",
    "EVENT_DEMO_DS4_ENGINE_START",
    "EVENT_DEMO_DS4_ENGINE_STOP",
    "EVENT_DEMO_DS4_DOOR_LOCK",
    "EVENT_DEMO_DS4_DOOR_UNLOCK",
    "EVENT_DEMO_DS4_TRUNK_UNLOCK",
    // END TEMPORARY SHOWCASE EVENTS FOR CES 2020

    //"EVENT_STORAGE_SD_CARD_INSERTED",
    "EVENT_STORAGE_SD_CARD_REMOVED",
    //"EVENT_STORAGE_SD_CARD_ERROR",
    //"EVENT_STORAGE_SD_CARD_NEEDS_FORMAT",
    //"EVENT_STORAGE_SD_CARD_FULL",
    //"EVENT_STORAGE_SD_CARD_TOO_SMALL",

    "EVENT_POSSIBLE_IMPACT",

    "EVENT_KLOUD_HISTORICAL_STREAMING",

     // Raven Vision Service Events (Mapbox currently)
     "EVENT_RAVEN_VISION_UNKNOWN",
     "EVENT_RAVEN_VISION_AUTHORIZATION",
     "EVENT_RAVEN_VISION_STARTED",
     "EVENT_RAVEN_VISION_STOPPED",
     "EVENT_RAVEN_VISION_CALIBRATION",
     "EVENT_RAVEN_VISION_RUN_STOP_SIGN",
     "EVENT_RAVEN_VISION_TAILGATING",
     "EVENT_RAVEN_VISION_HARD_BRAKING",
     "EVENT_RAVEN_VISION_HARD_ACCELERATION",
     "EVENT_RAVEN_VISION_HARD_CORNERING",
     "EVENT_RAVEN_VISION_COLLISION_WARNING",
     "EVENT_RAVEN_VISION_SPEED_LIMIT",
     "EVENT_RAVEN_VISION_LANE_CHANGE",

     "EVENT_CUSTOM",

     "EVENT_KLOUD_DRIVER_DISTRACTED_CELLPHONE",
     "EVENT_RAVEN_BAD_INSTALL_DETECTED",
     "EVENT_RAVEN_BAD_INSTALL_CLEARED",

    "EVENT_RAVEN_BT_BTN_SINGLE_PRESS",
    "EVENT_RAVEN_BT_BTN_DOUBLE_PRESS",
    "EVENT_RAVEN_BT_BTN_SINGLE_PRESS_AND_HOLD",
    "EVENT_RAVEN_BT_BTN_DOUBLE_PRESS_AND_HOLD",
    "EVENT_RAVEN_RED_LIGHT_VIOLATION"
]
allowedEvents.push(...events.map(event => event.proto.name));

var visibleEventsForReports = [
    'EVENT_HARD_BRAKING',
    "EVENT_HARD_CORNERING",
    'EVENT_SPEEDING_STARTED',
    'EVENT_AGGRESSIVE_ACCELERATION',
    'EVENT_RAVEN_VISION_TAILGATING',
    'EVENT_ACCIDENT',
    'EVENT_OBD_DTC_ALERT',
    'EVENT_IDLING_STARTED',
    "EVENT_POSSIBLE_IMPACT",
    "EVENT_KLOUD_DRIVER_DISTRACTED_CELLPHONE",
    "EVENT_RAVEN_UNPLUGGED",
    "EVENT_RAVEN_USER_SHUTDOWN",
    "EVENT_RAVEN_RED_LIGHT_VIOLATION"
]
visibleEventsForReports.push(...events.filter(event => event.visibility.reports).map(event => event.proto.name));

const visibleEventsForCoaching = [
    'EVENT_HARD_BRAKING',
    'EVENT_HARD_CORNERING',
    'EVENT_SPEEDING_STARTED',
    'EVENT_AGGRESSIVE_ACCELERATION',
    'EVENT_RAVEN_VISION_TAILGATING',
    //'EVENT_ACCIDENT',
    //'EVENT_OBD_DTC_ALERT',
    'EVENT_IDLING_STARTED',
    "EVENT_POSSIBLE_IMPACT",
    //"EVENT_KLOUD_DRIVER_DISTRACTED_CELLPHONE", // RAV-5960 (effectively removing from the filter drop-down list, but still allowing the event to be displayed via like 154 below)
    "EVENT_KLOUD_DRIVER_DETECTED",
    "EVENT_RAVEN_UNPLUGGED",
    "EVENT_KLOUD_LIVE_STREAMING",
    "EVENT_KLOUD_HISTORICAL_STREAMING",
    "EVENT_RAVEN_BT_BTN_PRESS",
    "EVENT_CUSTOM",
    "EVENT_RAVEN_RED_LIGHT_VIOLATION"
]
visibleEventsForCoaching.push(...events.filter(event => event.visibility.coaching).map(event => event.proto.name));

const visibleEventFlagsForCoaching = [
    "EVENT_FLAG_REVIEWED",
    "EVENT_FLAG_DISMISSED",
    "EVENT_FLAG_COACHING_REQUIRED",
    "EVENT_FLAG_COACHING_COMPLETED",
    "EVENT_FLAG_UNDER_INVESTIGATION",
    "EVENT_FLAG_FALSE_POSITIVE"
]


const visibleEventsForCoachingNoFacialRecognition = [
    'EVENT_HARD_BRAKING',
    'EVENT_HARD_CORNERING',
    'EVENT_SPEEDING_STARTED',
    'EVENT_AGGRESSIVE_ACCELERATION',
    'EVENT_RAVEN_VISION_TAILGATING',
    //'EVENT_ACCIDENT',
    //'EVENT_OBD_DTC_ALERT',
    'EVENT_IDLING_STARTED',
    "EVENT_POSSIBLE_IMPACT",
    //"EVENT_KLOUD_DRIVER_DETECTED",
    "EVENT_RAVEN_UNPLUGGED",
    "EVENT_KLOUD_LIVE_STREAMING",
    "EVENT_KLOUD_HISTORICAL_STREAMING",
    "EVENT_RAVEN_BT_BTN_PRESS",
    "EVENT_CUSTOM",
    "EVENT_RAVEN_RED_LIGHT_VIOLATION"
]
visibleEventsForCoachingNoFacialRecognition.push(...events.filter(event => event.visibility.coachingNoFacialRecognition).map(event => event.proto.name));

var visibleEventsForWarning = [
    //'EVENT_HARD_BRAKING',
    'EVENT_SPEEDING_STARTED', // (percent over limit is a factor)
    //'EVENT_AGGRESSIVE_ACCELERATION',
    //'EVENT_ACCIDENT',
    //'EVENT_OBD_DTC_ALERT',
    'EVENT_IDLING_STARTED', // (duration is a factor)
    //'EVENT_RAVEN_SHUTDOWN',
    //'EVENT_RAVEN_UNPLUGGED',
    //"EVENT_RAVEN_USER_SHUTDOWN",
    //'EVENT_STORAGE_SD_CARD_REMOVED',
    "EVENT_POSSIBLE_IMPACT",
    "EVENT_RAVEN_BAD_INSTALL_DETECTED",
    "EVENT_RAVEN_BAD_INSTALL_CLEARED"
]
visibleEventsForWarning.push(...events.filter(event => event.visibility.warning).map(event => event.proto.name));

//no longer used to change and parse string
//is still used to prevent propagating certain events.
document.filterEvent = (event) => {

    if (!event || !event.type) {
        console.error("event type undefined", event);
        return null; //there was a case on prod where event.type was undefined. Just removing this event for now until I can find out why.
    }
    if (allowedEvents.indexOf(event.type) == -1) {
        return null;
    } else {
        return event;
    }
}


document.filterEventTypeAllowedForWarningContext = (eventTypeName) => {

    var warningEventList = document.getEventListForContext("warning");

    if (warningEventList.indexOf(eventTypeName) == -1) {
        return false;
    } else {
        return true;
    }
}

document.filterEventTypeAllowed = (eventTypeName) => {

    if (allowedEvents.indexOf(eventTypeName) == -1) {
        return false;
    } else {
        return true;
    }
}

document.getEventListForContext = (context) => {
    switch (context) {
        case "reports":
            return visibleEventsForReports;
        case "coaching":
            return visibleEventsForCoaching;
        case "coaching_no_facial_recognition":
            return visibleEventsForCoachingNoFacialRecognition;
        case "warning":
            return visibleEventsForWarning;
        case "coaching_flags":
            return visibleEventFlagsForCoaching;
        default:
            return allowedEvents;
    }
}

document.getEventFlagName = (event) => {

    switch (event.type) {
        case "EVENT_FLAG_REVIEWED":
            return strings.event_flag_title_reviewed;

        case "EVENT_FLAG_DISMISSED":
            return strings.event_flag_title_dismissed;

        case "EVENT_FLAG_COACHING_REQUIRED":
            return strings.event_flag_title_coaching_required;

        case "EVENT_FLAG_COACHING_COMPLETED":
            return strings.event_flag_title_coaching_completed;

        case "EVENT_FLAG_UNDER_INVESTIGATION":
            return strings.event_flag_title_under_investigation;
            
        case "EVENT_FLAG_FALSE_POSITIVE":
            return strings.event_flag_title_report_false_positive;
            
        default:
            errorReporting.error(`Unrecognized event flag: ${event.type}`);
            return event.type;
    }
}

document.getEventName = (event) => {

    const eventConfig = events.find(e => e.proto.name === event.type);

    if (eventConfig) {
        if (strings["event_title_" + eventConfig.snakeName]) {
            return strings["event_title_" + eventConfig.snakeName];
        }
    }

    switch (event.type) {
        case "EVENT_ENGINE_ON":
            return strings.event_title_engine_on;

        case "EVENT_ENGINE_OFF":
            return strings.event_title_engine_off;

        case "EVENT_ENGINE_UNKNOWN":
            return strings.event_title_engine_unknown;

        case "EVENT_CAR_BATTERY_LOW":
            return strings.event_title_car_battery_low;

        case "EVENT_OBD_DTC_ALERT":
            return strings.event_title_engine_fault;

        case "EVENT_OBD_DTC_CLEARED":
            return strings.event_title_engine_fault_cleared;

        case "EVENT_RAVEN_UNPLUGGED":
            return strings.event_title_raven_unplugged;

        case "EVENT_RAVEN_PLUGGED_IN":
            return strings.event_title_raven_plugged_in;

        case "EVENT_RAVEN_USER_SHUTDOWN":
            return strings.event_title_raven_user_shutdown;

        case "EVENT_RAVEN_SHUTDOWN":
            return strings.event_title_raven_shutdown;

        case "EVENT_HARD_BRAKING":
            return strings.event_title_hard_braking;

        case "EVENT_HARD_CORNERING":
            return strings.event_title_hard_cornering;

        case "EVENT_HIGH_SPEED":
            return strings.event_title_high_speed;

        case "EVENT_ACCIDENT":
            return strings.event_title_accident;

        case "EVENT_AGGRESSIVE_ACCELERATION":
            return strings.event_title_aggressive_acceleration;
            
        case "EVENT_SOUND_IMPULSE":
            return strings.event_title_sound_impulse;

        case "EVENT_SOUND_BREAKING_GLASS":
            return strings.event_title_sound_breaking_glass;

        case "EVENT_CAR_BUMPED":
            return strings.event_title_car_bumped;

        case "EVENT_SPEEDING_STARTED":
            return strings.event_title_speeding_started;

        case "EVENT_SPEEDING_STOPPED":
            return strings.event_title_speeding_stopped;

        case "EVENT_SPEEDING_MERGED":
            return strings.event_title_speeding_merged;

        case "EVENT_IDLING_STARTED":
            return strings.event_title_idling_started;

        case "EVENT_RAVEN_VISION_RUN_STOP_SIGN":
            return strings.event_title_raven_vision_run_stop_sign;

        case "EVENT_RAVEN_VISION_TAILGATING":
            return strings.event_title_raven_vision_tailgating;

        case "EVENT_IDLING_STOPPED":
            return strings.event_title_idling_stopped;

        case "EVENT_IDLING_MERGED":
            return strings.event_title_idling_merged;

        case "EVENT_RAVEN_BT_BUTTON_SHORT_PRESS":
        case "EVENT_RAVEN_BT_BUTTON_LONG_PRESS":
        case "EVENT_RAVEN_BT_BTN_SINGLE_PRESS":
        case "EVENT_RAVEN_BT_BTN_DOUBLE_PRESS":
        case "EVENT_RAVEN_BT_BTN_SINGLE_PRESS_AND_HOLD":
        case "EVENT_RAVEN_BT_BTN_DOUBLE_PRESS_AND_HOLD":
        case "EVENT_RAVEN_BT_BTN_PRESS":
            return strings.event_title_button_pressed;

        case "EVENT_KLOUD_GEOFENCE_ENTER": // Kloud version can probably be removed
        case "EVENT_RAVEN_GEOFENCE_ENTER":
            return strings.event_title_geofence_enter;

        case "EVENT_KLOUD_GEOFENCE_EXIT": // Kloud version can probably be removed
        case "EVENT_RAVEN_GEOFENCE_EXIT":
            return strings.event_title_geofence_exit;

        case "EVENT_KLOUD_DRIVER_DETECTED":
            return strings.event_title_driver_detected;

        case "EVENT_KLOUD_PASSENGER_DETECTED":
            return strings.event_title_passenger_detected;

        case "EVENT_RAVEN_DEBUG_EVENT":
        case "EVENT_KLOUD_DEBUG_EVENT":
            return event.description;

        case "EVENT_KLOUD_LIVE_STREAMING":
            return strings.event_title_live_streaming;

        case "EVENT_KLOUD_HISTORICAL_STREAMING":
            return strings.event_title_historical_streaming;

        case "EVENT_STORAGE_SD_CARD_INSERTED":
            return strings.event_title_storage_sd_card_inserted;
        case "EVENT_STORAGE_SD_CARD_REMOVED":
            return strings.event_title_storage_sd_card_removed;
        case "EVENT_STORAGE_SD_CARD_ERROR":
            return strings.event_title_storage_sd_card_error;
        case "EVENT_STORAGE_SD_CARD_NEEDS_FORMAT":
            return strings.event_title_storage_sd_card_needs_format;
        case "EVENT_STORAGE_SD_CARD_FULL":
            return strings.event_title_storage_sd_card_full;
        case "EVENT_STORAGE_SD_CARD_TOO_SMALL":
            return strings.event_title_storage_sd_card_too_small;

        case "EVENT_POSSIBLE_IMPACT":
            return strings.event_title_possible_impact;

        case "EVENT_CUSTOM":
            return strings.event_title_custom;

        case "EVENT_KLOUD_DRIVER_DISTRACTED_CELLPHONE":
            return strings.event_title_driver_distracted_cellphone;

        case "EVENT_RAVEN_BAD_INSTALL_DETECTED":
            return strings.event_title_bad_install_detected;
        case "EVENT_RAVEN_BAD_INSTALL_CLEARED":
            return strings.event_title_bad_install_cleared;

        // TEMPORARY SHOWCASE EVENTS FOR CES 2020
        case "EVENT_DEMO_MAPBOX_TAILGATING":
            return strings.event_title_demo_mapbox_tailgating;
        case "EVENT_DEMO_MAPBOX_ROLLING_STOP":
            return strings.event_title_demo_mapbox_rolling_stop;
        case "EVENT_DEMO_MAPBOX_SAFETY_WARNING":
            return strings.event_title_demo_mapbox_safety_warning; // Pedestrian or Cyclist
        case "EVENT_DEMO_DS4_ALARM_ON":
            return strings.event_title_demo_ds4_alarm_on;
        case "EVENT_DEMO_DS4_ALARM_OFF":
            return strings.event_title_demo_ds4_alarm_off;
        case "EVENT_DEMO_DS4_ENGINE_START":
            return strings.event_title_demo_ds4_engine_start;
        case "EVENT_DEMO_DS4_ENGINE_STOP":
            return strings.event_title_demo_ds4_engine_stop;
        case "EVENT_DEMO_DS4_DOOR_LOCK":
            return strings.event_title_demo_ds4_door_lock;
        case "EVENT_DEMO_DS4_DOOR_UNLOCK":
            return strings.event_title_demo_ds4_door_unlock;
        case "EVENT_DEMO_DS4_TRUNK_UNLOCK":
            return strings.event_title_demo_ds4_trunk_unlock;
        // END TEMPORARY SHOWCASE EVENTS FOR CES 2020

        default:
            errorReporting.error(`Unrecognized event type: ${event.type}`);
            return event.type;
    }
}

document.getSDCardStatusName = (stat) => {

    if (!stat) return '';

    switch (stat) {
        case "INSERTED":
            return strings.sdcard_title_inserted;
        case "REMOVED":
            return strings.sdcard_title_removed;
        case "ERROR":
            return strings.sdcard_title_error;
        case "NEEDS_FORMAT":
            return strings.sdcard_title_needs_format;
        case "CARD_FULL":
            return strings.sdcard_title_card_full;
        case "CARD_TOO_SMALL":
            return strings.sdcard_title_card_too_small;
        case "UNKNOWN":
        default:
            return strings.sdcard_title_unknown;
    }
}

//returns an array from the end of the line of length 'length'
//array will be in same order as array eg. index -> end of array
Array.prototype.endSegment = function (lengthFromEnd) {
    return this.slice(this.length - lengthFromEnd, this.length);
}
//element from end. -1 is last element.
Array.prototype.elementFromEnd = function (indexFromEnd) {
    return this.slice(this.length + indexFromEnd, this.length)[0];
}
Array.prototype.last = function () {
    return this.slice(this.length - 1, this.length)[0];
}
Array.prototype.pop = function () {
    return this.splice(this.length - 1, 1)[0];
}
Array.prototype.remove = function (element) {
    this.splice(this.indexOf(element), 1);
}
if (!Array.prototype.find) {
    Array.prototype.find = function (element) {
        return this[this.indexOf(element)];
    }
}

//string extensions
String.prototype.contains = function (string) {
    return this.indexOf(string) > -1;
}

//parse url params
window.location.getParams = function () {
    var params = {};
    var parser = document.createElement('a');
    parser.href = this;
    console.log(this);
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};
